const globalState = {
  menuOpened: localStorage.getItem("sideBarMenuOpened") === "true"
}

export default globalState
